module.exports = __webpack_public_path__ + "img/lightblue_student.b50ba165.gif";